import './Header.scss'
import { Link } from "react-router-dom"
import ProfileSvg from "../../assets/svg/ProfileSvg"

function Header() {
    return (
        <header className="header">
            <Link to="/">
                <div className="header-left">
                    <img src="/img/logo.JPEG" alt="Logo" className="header-logo" />
                </div>
            </Link>

            <div className='header-center'>
                <h1>Aniverse Card</h1>
            </div>

            <Link to="/profile">
                <div className='header-right'>
                    <ProfileSvg className="profile-icon" />
                </div>
            </Link>
        </header>
    )
}

export default Header;
